export default __webpack_public_path__ + "static/media/HomeUse.01d947c4.png";